export class AuthQuery
{
    constructor(
        public App: string,
        public Password: string
    ) { }
}
